module.exports = __webpack_public_path__ + "static/media/icons8-binoculars-250.4c2f93c1.png";